import VehicleDetailEdit from '@/modules/mdm/views/vehicle-details/edit';
import VehicleDetails from '@/modules/mdm/views/vehicle-details/index';
import Users from '@/modules/mdm/views/users/index';
import DriverDetails from '@/modules/mdm/views/driver-details/index';
import NdcSubmissionList from '@/modules/mdm/views/ndc/index';

const mdm = [
  {
    path: '/mdm/vehicledetail',
    name: 'VehicleDetail',
    component: VehicleDetails,
    meta: {
      title: 'VehicleDetails',
    },
  },
  {
    path: '/mdm/vehicledetail/:id/details',
    name: 'VehicleDetailEdit',
    component: VehicleDetailEdit,
    meta: {
      title: 'Vehicle Details',
      requiresAuth: true,
      sectionName: 'vehicledetail',
    },
  },
  {
    path: '/mdm/users',
    name: 'Users',
    component: Users,
    meta: {
      title: 'Users',
      sectionName: 'users',
    },
  },
  {
    path: '/mdm/driverdetail',
    name: 'DriverDetail',
    component: DriverDetails,
    meta: {
      title: 'DriverDetails'
    }
  },
  {
    path: '/mdm/ndc',
    name: 'ndc_master',
    component: NdcSubmissionList,
    meta: {
      title: 'NDC Master',
    },
  },
];

export default mdm;
